/* eslint-disable react/jsx-key */
import React, { Component, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Row, Col, Card, Button, Input, Select, message, Table, Icon } from 'antd'
import Dropzone from 'react-dropzone'
import F from '../../Functions'
import axios from 'axios'
import { Translate } from 'react-translated'
import Pagination from "../../components/pagination";
import { Link } from 'react-router-dom'
import ViewVideoModal from './viewVideoModal'
import Cookies from 'js-cookie'
import './trainingDetails.css'
const { Meta } = Card;

const columns = [
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
  },
  {
    title: "Video Url",
    dataIndex: "url",
    key: "url",
  },
  {
    title: "Thumbnail Url",
    dataIndex: "thumbnail_url",
    key: "thumbnail_url",
  },
  {
    title: "Created On",
    dataIndex: "created_on",
    key: "created_on",
  },

  {
    title: "Uploaded On",
    dataIndex: "updated_on",
    key: "updated_on",
  }
];

function TrainingDetails(props) {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [page, setpage] = useState(1)
  const [total_pages, settotal_pages] = useState(0)
  const [isViewVideoModal, setIsViewVideoModal] = useState(false)
  const [contentData, setContentData] = useState({})


  useEffect(() => {

    loadVideos(page)

  }, [])

  const loadVideos = (page) => {
    setLoading(true)
    let api = `/api/v1/training_video?page=${page}`

    axios.get(api).then(e => {
      F.log('training videos = > ', e.data)
      setLoading(true)
      if (e.data && e.data.objects) {
        setData(e.data.objects)
        setpage(e.data.page)
        settotal_pages(e.data.total_pages)
        setLoading(false)
      }

    })
      .catch((error) => {
        F.log('error in getting videos = > ', error)
      })
  }


  const onCancel = () => {
    setIsViewVideoModal(false)
  }


  const setVideoContent = (data) => {

    if (data.url.startsWith('https://www.loom.com')) {
      window.open(data.url, "_blank")
    } else {
      setContentData(data);
      setIsViewVideoModal(true)
    }

  }

  const deleteVideo = (video) => {
    F.log('delete Video => ', video)
    let data = {
      active: 0,
    }
    setLoading(true)
    axios
      .put(`/api/training_video/${video.id}`, data)
      .then((res) => {
        F.log('response = > ', res.data)
        message.success(F.translate(`Video Deleted`))
        loadVideos(page)
      })
      .catch((e) => {
        message.error(F.translate(`Unable to delete video`))
      })
      setLoading(false)
  }

  let user = typeof Cookies.get("user_info") !== "undefined"
    ? JSON.parse(Cookies.get("user_info"))
    : {}



  return (
    <div>
      <Card
        type="inner"
        className="tableCard"
        // title={<Translate text={`Upload Training Content Details`} />}
        title={<React.Fragment><Icon style={{ color: "#1890ff", marginRight: "5px" }} type="video-camera" /> <Translate text={` Upload Training Content Details`} /></React.Fragment>}
        loading={loading}
        bodyStyle={{ padding: 0, overflow: 'visible', minHeight: 'auto', height: 'auto' }}
      >
        <div style={{ display: 'flex', flexWrap: 'wrap', margin: '0', padding: '10px' }}>
          {data.map((e, i) => {
            return (
              <Card
                key={i}
                hoverable
                bodyStyle={{ padding: "10px 0px" }}
                className='videoList'
                cover={<img onClick={() => setVideoContent(e)}
                  style={{ objectFit: 'fill', cursor: 'pointer' }}
                  alt={e.title} src={e.thumbnail_url}
                  role="button"
                  tabIndex="0"
                  onKeyPress={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      setVideoContent(e);
                    }
                  }}
                />}
              >
                <div>
                  <div style={{ float: 'right', display: user.user_type !== 'SUPER_ADMIN' && "none" }}>
                    <Button onClick={() => deleteVideo(e)}
                      loading={loading}
                      className="borderRadius-28"
                      style={{ border: "1px solid red", color: 'red' }}>
                      Delete</Button>
                  </div>
                  <h5 style={{wordWrap:'break-word'}}>{e.title}</h5>
                  <p style={{wordWrap:'break-word'}}>{e.description}</p>

                </div>
                {/* <Meta style={{padding:0}} title={e.title} description={e.description} /> */}
              </Card>
            )
          })}

        </div>



        {/* <Table
            columns={columns}
            dataSource={data}
            bordered={false}
            pagination={false}
          />

         <Pagination
            current_page={page}
            total_pages={total_pages}
            // onClick={(page) => {
            //   this.loadAgencies(page);
            // }}
          /> */}

      </Card>

      <Pagination
        className="pagination-container cpagination"
        current_page={page}
        total_pages={total_pages}
        onClick={(page) => {
          loadVideos(page);
        }}
      />

      <ViewVideoModal data={contentData} onCancel={onCancel} isViewVideoModal={isViewVideoModal} />
    </div>
  )
}

export default TrainingDetails


// WEBPACK FOOTER //
// ./src/scenes/Training/trainingDetails.js